import { FormattedMessage } from "react-intl";
import NationalTextField from "./NationalTextField";
import NationalSelectField from "./NationalSelectField";

export default function PersonalDataSection({
  register,
  errors,
  dir,
  currentLocale,
  trainingPrograms,
  governorates,
}) {
  return (
    <div className="data-form">
      <h5
        className="fw-bold mb-4 text-decoration-underline"
        style={{ color: "var(--main-color)" }}
      >
        <FormattedMessage id="personalData" />
      </h5>

      <NationalSelectField
        register={register}
        name="trainingProgramId"
        labelId="trainingProgram"
        dir={dir}
        currentLocale={currentLocale}
        options={trainingPrograms}
        optionTranslationsKey="translations"
      />
      <NationalTextField
        register={register}
        name="name"
        labelId="quadName"
        error={errors?.name}
      />
      <NationalTextField
        register={register}
        name="nationalId"
        labelId="nationalId"
        type="number"
        error={errors?.nationalId}
      />
      <NationalTextField
        register={register}
        name="residence"
        labelId="residence"
        error={errors?.residence}
      />
      <NationalSelectField
        register={register}
        name="governorate"
        labelId="governorate"
        dir={dir}
        currentLocale={currentLocale}
        options={governorates}
        optionTranslationsKey="governorateTranslations"
        variant="container"
        error={errors?.governorate}
      />
      <NationalTextField
        register={register}
        name="phoneNumber"
        labelId="phoneNumber"
        type="tel"
        error={errors?.phoneNumber}
      />
      <NationalTextField
        register={register}
        name="email"
        labelId="email"
        type="email"
        error={errors?.email}
      />
    </div>
  );
}
